
<script>
    import data from '../data/visi-misi.json'
    export default {
        components: {
        },
        data () {
            return {
                data
            }
        }
    };
</script>
<template>
    <div class="page-wrapper section-space--inner--80">
        <div class="blog-section">
            <div class="container">
                <div class="row section-space--bottom--40">
                    <div class="col-lg-12"><img src="assets/img/projects/project-details.jpg" class="img-fluid" alt="image"></div>
                </div>
                <div class="row mb-5">
                    <div class="col-sm-12">
                        <h3>Visi</h3>
                        <p class="font-size-17 font-weight-bolder ml-3">{{data.visi}}</p>
                    </div>
                </div>
               <div class="row mb-5">
                    <div class="col-sm-12">
                        <h3>Misi</h3>
                        <ul class="list-style section-space--top--10">
                           <li v-for="item in data.misi" :key="item.id">{{item.content}}</li>
                        </ul>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-sm-12">
                        <h3>Tujuan</h3>
                        <ol class="section-space--top--10">
                           <li v-for="item in data.tujuan" :key="item.id">{{item.content}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
  .list-style {
    list-style: square;
    margin-left: 40px;
  }
  
</style>
